import { apiClient, type ApiClientResponse } from 'common/services';

export const getFile = async (url: string, skipAuth = true) => {
  return apiClient.get<Blob, ApiClientResponse<Blob>>(url, { skipAuth, responseType: 'blob' });
};
